module.exports = __webpack_public_path__ + "img/icon_sb_white_glove_16x16.1379d11.svg";